<template>
 <div class="login-container">
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <div style="color: transparent;">占位符</div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-form ref="ruleForm2" :model="ruleForm2" :rules="rules2" class="login-form" label-position="left">
          <div class="title">请用飞书扫码登录</div>
		  <div id="login_container"></div>

        </el-form>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import axios from 'axios'
  var QRLoginObj= null
  var handleMessage = function (event) {
	 var goto = "http://ad.gamebrain.io/feishu/callback"
    var origin = event.origin;
    // 使用 matchOrigin 方法来判断 message 来自页面的url是否合法
    if( QRLoginObj.matchOrigin(origin) ) {
        var loginTmpCode = event.data;
      	// 在授权页面地址上拼接上参数 tmp_code，并跳转
		  window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a1b409d6b6fb100c&redirect_uri=${goto}&response_type=code&state=STATE&tmp_code=${loginTmpCode}`
    }
};
if (typeof window.addEventListener != 'undefined') {
    window.addEventListener('message', handleMessage, false);}
else if (typeof window.attachEvent != 'undefined') {
    window.attachEvent('onmessage', handleMessage);
}
  export default {
    data() {
      return {
        loading: false,
		form:{},
        ruleForm2: {
          account: '',
          password: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: false
      };
    },
	created:function() {
		var _this = this;
		let token = this.$route.params.token
		if(token)
		{
		  return this.login(token)
		}
	},
	mounted(){
	    QRLoginObj = QRLogin({
		id:"login_container",
		goto: "https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a1b409d6b6fb100c&redirect_uri=http://ad.gamebrain.io/feishu/callback&response_type=code&state=STATE",
		width: "255",
		height: "255",
		style: "border: 1px solid #eee;"
	});
	},
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
	  login(token){
      	var _this = this
		axios({
			method: 'post',
			url: 'http://ad.gamebrain.io/user/loginBytoken',
			data:{token:token}
		}).then(function (response) {
		  _this.loading = false
		  if(response.data.code==200)
		  {
		  	sessionStorage.setItem('user', JSON.stringify(response.data.data));
			_this.$router.push({ path: '/home' });
		  }else{
		  	_this.$message.error('登录失败');
		  }
		})
	  },
      handleSubmit2(ev) {
		  this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
			  this.loading = true
			  var loginParams = { account: this.ruleForm2.account, password: this.ruleForm2.password };
			  this.login('http://ad.gamebrain.io/api/login',loginParams)
          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
#login_container {
		display: flex;
    	justify-content: center;
	}
  .login-container {
    height: 100vh;
    background: url("~@/assets/background.jpg") center center fixed
      no-repeat;
    background-size: cover;
    .title {
      font-size:24px;
      font-weight: 500;
      color: rgba(14, 18, 26, 1);
	  margin:20px 0px;
	  text-align: center;
    }
    .title-tips {
      margin-top: 29px;
      font-size: 26px;
      font-weight: 400;
      color: rgba(14, 18, 26, 1);
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .login-btn {
      display: inherit;
      width:100%;
      height: 40px;
      margin-top: 5px;
      border: 0;
      &:hover {
        opacity: 0.9;
      }
    }
    .login-form {
      position: relative;
      max-width: 100%;
      margin: calc((100vh - 425px) / 2) 10% 10%;
      overflow: hidden;
      .forget-password {
        width: 100%;
        margin-top: 40px;
        text-align: left;
        .forget-pass {
          width: 129px;
          height: 19px;
          font-size: 20px;
          font-weight: 400;
          color: rgba(92, 102, 240, 1);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?ce4cd12e